// assets/tf-recently-viewed.js
class TFRecentlyViewed {
  static storageKey = 'tf_recently_viewed_v1';
  static selector = '[data-tf-recently]';

  constructor(root) {
    this.root = root;
    this.limit = parseInt(root.dataset.limit || '8', 10) || 8;

    this.slider = root.querySelector('.swiper-slider');
    this.wrapper = root.querySelector('[data-tf-recently-wrapper]');
    this.grid = root.querySelector('[data-tf-recently-grid]');

    this.mounted = false;
    this.mount();
  }

  // ---------- Storage ----------
  static readList() {
    try {
      const raw = localStorage.getItem(TFRecentlyViewed.storageKey);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (_) {
      return [];
    }
  }

  static writeList(arr) {
    try {
      localStorage.setItem(TFRecentlyViewed.storageKey, JSON.stringify(arr));
    } catch (_) {}
  }

  static trackCurrentProduct() {
    const current = window.__tfRecent && window.__tfRecent.current;
    if (!current || !current.handle) return;

    const list = TFRecentlyViewed.readList();

    // remove duplicate by handle
    const filtered = list.filter(x => x && x.handle && x.handle !== current.handle);

    // push to top
    filtered.unshift({ handle: current.handle, ts: current.ts || Date.now() });

    // keep max 50
    TFRecentlyViewed.writeList(filtered.slice(0, 50));
  }

  // ---------- Rendering ----------
  getSwiperCtor() {
    return window.Swiper || (window.swiper && window.swiper.Swiper) || null;
  }

  toInt(v, fallback = 0) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }
  toBool(v, fallback = false) {
    if (v === undefined || v === null) return fallback;
    return String(v).toLowerCase() === 'true';
  }

  buildSwiperConfig() {
    const el = this.slider;

    const preview = this.toInt(el.dataset.preview, 4);
    const tablet = this.toInt(el.dataset.tablet, 3);
    const mobileSm = this.toInt(el.dataset.mobileSm, 2);
    const mobile = this.toInt(el.dataset.mobile, 2);

    const spaceLg = this.toInt(el.dataset.spaceLg, 30);
    const spaceMd = this.toInt(el.dataset.spaceMd, 20);
    const space = this.toInt(el.dataset.space, 15);

    const hasPagination = this.toBool(el.dataset.pagination, true);

    const prevEl = this.root.querySelector('.nav-prev-swiper');
    const nextEl = this.root.querySelector('.nav-next-swiper');
    const paginationEl = this.root.querySelector('.tf-sw-pagination');

    const config = {
      slidesPerView: preview,
      spaceBetween: spaceLg,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: { slidesPerView: mobile, spaceBetween: space },
        576: { slidesPerView: mobileSm, spaceBetween: space },
        768: { slidesPerView: tablet, spaceBetween: spaceMd },
        1200: { slidesPerView: preview, spaceBetween: spaceLg }
      },
      navigation: (prevEl && nextEl) ? { prevEl, nextEl } : undefined,
      pagination: (hasPagination && paginationEl) ? { el: paginationEl, clickable: true } : undefined
    };

    return config;
  }

  initSwiper() {
    if (!this.slider) return;
    const SwiperCtor = this.getSwiperCtor();
    if (!SwiperCtor) return;

    if (this.slider.swiper) {
      try { this.slider.swiper.destroy(true, true); } catch (_) {}
    }

    try {
      new SwiperCtor(this.slider, this.buildSwiperConfig());
    } catch (e) {
      console.warn('[TFRecentlyViewed] Swiper init failed:', e);
    }
  }

  async fetchCardHTML(handle) {
    // Fetch a single product page with sections= render section
    const url = `/products/${encodeURIComponent(handle)}?sections=render-product-card`;

    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) return '';

    const data = await res.json().catch(() => null);
    if (!data || !data['render-product-card']) return '';

    const doc = new DOMParser().parseFromString(data['render-product-card'], 'text/html');
    const node = doc.querySelector('[data-tf-recently-card]');
    return node ? node.innerHTML : '';
  }

  async mount() {
    if (this.mounted) return;
    this.mounted = true;

    // lấy list đã lưu
    let list = TFRecentlyViewed.readList();

    // nếu đang ở product page, remove chính nó khỏi list (để khỏi hiển thị trùng)
    const current = window.__tfRecent && window.__tfRecent.current;
    if (current && current.handle) {
      list = list.filter(x => x && x.handle !== current.handle);
    }

    const handles = list
      .filter(x => x && x.handle)
      .sort((a, b) => (b.ts || 0) - (a.ts || 0))
      .slice(0, this.limit)
      .map(x => x.handle);

    if (!handles.length) {
      this.root.style.display = 'none';
      return;
    }

    // fetch song song, giữ thứ tự
    const htmlList = await Promise.all(handles.map(h => this.fetchCardHTML(h)));

    const cardsHTML = htmlList.filter(Boolean);
    if (!cardsHTML.length) {
      this.root.style.display = 'none';
      return;
    }

    if (this.wrapper) {
      this.wrapper.innerHTML = cardsHTML
        .map(html => `<div class="swiper-slide">${html}</div>`)
        .join('');
      this.initSwiper();
    } else if (this.grid) {
      // grid đơn giản nếu không dùng swiper (bạn có thể thay class theo theme)
      this.grid.innerHTML = `<div class="grid">${cardsHTML.map(h => `<div class="grid__item">${h}</div>`).join('')}</div>`;
    }

    // Nếu bạn có infiniteSlide hoặc component khác cần re-mount sau inject:
    if (window.InfiniteSlide) window.InfiniteSlide.mountAll(this.root);
  }

  // ---------- Static mount ----------
  static mountAll(scope = document) {
    scope.querySelectorAll(TFRecentlyViewed.selector).forEach(root => {
      if (root.__tfRecentlyMounted) return;
      root.__tfRecentlyMounted = true;
      new TFRecentlyViewed(root);
    });
  }
}

// Track current product ASAP (product page)
TFRecentlyViewed.trackCurrentProduct();

// Mount section(s)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => TFRecentlyViewed.mountAll(), { once: true });
} else {
  TFRecentlyViewed.mountAll();
}

// Theme editor
document.addEventListener('shopify:section:load', (e) => {
  TFRecentlyViewed.mountAll(e.target);
});
